module.exports = __webpack_public_path__ + "static/media/Slaking_gaussian2.cf9832ed.png";